import { NavItem } from '@app/components/layout/sidenav/link/NavItem';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { FormattedMessage } from 'react-intl';
import { SettingsRoutes } from '../../../modules/settings/routing/SettingsRoutes';

export function AdminImpersonationCta() {
  return (
    <NavItem to={SettingsRoutes.ROUTES.impersonation} icon={<AdminPanelSettingsIcon />}>
      <span
        style={{
          fontSize: 'small',
          textTransform: 'none',
          fontWeight: 400,
        }}
      >
        <FormattedMessage id="auth.userInfo.changeUser" defaultMessage="Cambiar usuario" />
      </span>
    </NavItem>
  );
}
